'use strict';

import 'js-cookie';

const Cookies = require('js-cookie');

/**
 * Top Load
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

function autoClick (el, time, defTime) {
	setTimeout(function () {
		el.trigger('click');
	}, time || defTime);
}

function addNumberToRoi () {
	$('.js-promo-code').text(window.roistat.visit).addClass('promocode__number--is-load');
}

(function ($) {
	$(window).on('load', function () {
		if (window.counters !== undefined) {
			for (var i = 0; i < window.counters.length; i++) {
				window.counters[i]();
			}
		}

		window.onRoistatAllModulesLoaded = function () {
			setTimeout(function () {
				addNumberToRoi();
			}, 1000);
		};

		// addNumberToRoi();

		(function () {
			let $el = $('.lozad-force');
			if ($el.length) {
				$el.get().forEach(item => {
					window.lazyLoad.triggerLoad(item);
				});
			}
		}());

		// (function () {
		// 	let url = window.location.search;
		// 	let $el = $('.js-mfp-auto');
		// 	let time = +$el.data('time');
		// 	if (url.indexOf('ratingruneta.ru') !== -1 && $el.length) {
		// 		autoClick($el, time, 30000);
		// 	}
		// }());

		(function () {
			let hash = window.location.hash;
			let $el = $('.js-auto-play');
			if (hash === '#auto-play' && $el.length) {
				autoClick($el, 50, 50);
			}
		}());

		(function () {
			let cookieFlag = Cookies.get('cookie-msg');

			if (!cookieFlag) {
				$('.cookie').addClass('cookie--visible');

				$('.js-hide-cookie').on('click', function (event) {
					event.preventDefault();
					$('.cookie').removeClass('cookie--visible');
					Cookies.set('cookie-msg', {expires: 60 * 60 * 24 * 365});
				});
			}
		}());
	});
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/load.js